import { fetchProductTypeRatings } from '@/utils/http/fetchProductTypeRatings';
import { Thunk } from '@/redux/types';
import { ProductTypesActionTypes, ProductTypesRatingsSetAction } from '../types';

export const fetchProductTypesRatingsAction: Thunk<
  Promise<void>,
  ProductTypesRatingsSetAction
> = async (dispatch) => {
  const ratings = await fetchProductTypeRatings();
  dispatch({
    type: ProductTypesActionTypes.PRODUCT_TYPES_RATINGS_SET,
    ratings,
  });
};
